<div class="card__section">
  <div class="row">
    <div class="columns">
      <h3 class="card__title card__title--large u-m-b-8">Schedules</h3>
    </div>
    <div class="columns shrink">
      <p class="u-m-b-0 typography--body" aria-live="polite">
        Viewing <strong>{{ dataResults?.length || 0 }}</strong>
      </p>
    </div>
  </div>
</div>
<div class="card__section">
  <div class="row align-middle">
    <div class="columns">
      <label for="databaseFilter">Databases</label>
      <select id="databaseFilter" class="u-m-b-0" [formControl]="databaseCtrl">
        <option *ngFor="let s of databases" [value]="s.value">{{ s.key }}</option>
      </select>
    </div>
  </div>
</div>
